import { render } from "./PaymentStatusLabel.vue?vue&type=template&id=48f9b21d"
import script from "./PaymentStatusLabel.vue?vue&type=script&lang=js"
export * from "./PaymentStatusLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__